import React from "react";
import { motion } from "framer-motion";
import { cn } from "./cn";

const VARIANTS = {
  primary: "bg-accent text-accent-fg hover:bg-accent-strong shadow-soft",
  secondary: "bg-surface text-ink border border-line hover:bg-surface-2 hover:border-line-strong shadow-soft",
  outline: "border border-line text-ink hover:bg-surface-2 hover:border-line-strong",
  ghost: "text-muted hover:bg-surface-2 hover:text-ink",
  danger: "bg-red-500 text-white hover:bg-red-600 shadow-soft",
};

const SIZES = {
  sm: "h-9 px-3 text-[13px] gap-1.5",
  md: "h-10 px-4 text-sm gap-2",
  lg: "h-11 px-5 text-sm gap-2",
  icon: "h-9 w-9",
};

export default function Button({
  variant = "primary",
  size = "md",
  className,
  children,
  loading = false,
  icon: Icon,
  disabled,
  ...props
}) {
  return (
    <motion.button
      whileTap={{ scale: 0.97 }}
      disabled={disabled || loading}
      className={cn(
        "inline-flex items-center justify-center rounded-lg font-medium outline-none transition-colors",
        "focus-visible:ring-2 focus-visible:ring-ring/40 focus-visible:ring-offset-2 focus-visible:ring-offset-bg",
        "disabled:pointer-events-none disabled:opacity-60",
        VARIANTS[variant],
        SIZES[size],
        className
      )}
      {...props}
    >
      {loading ? (
        <span className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
      ) : Icon ? (
        <Icon size={18} weight="bold" />
      ) : null}
      {children}
    </motion.button>
  );
}
